module.exports = __webpack_public_path__ + "img/60.da3bf34f.webp";